import {LEGEND_INITIAL_STATE} from "./legend.constants";

export const legendReducer = (state = LEGEND_INITIAL_STATE, action) => {
    switch (action.type) {
        default:
            return {...state};
    }
};
